import React, { useEffect, useState } from 'react';
import { Table } from '@mantine/core';
import '../../../scss/vendors/bstyles.scss';
import './styles.scss';
import THead from './THead';
import TBody from './TBody';
import { DataTablesProps, SortDirection, SortedConfigurationTable } from '.';
import LoaderDataTables from './LoaderDataTables';
import TPagination, { DropdownComponent } from './TPaginantion';

export const defaultSizeTable = [
  {
    label: '10',
    value: 10
  },
  {
    label: '20',
    value: 20
  },
  {
    label: '50',
    value: 50
  },
  {
    label: '100',
    value: 100
  }
];

const DataTables: React.FC<DataTablesProps> = ({
  columns,
  data,
  loading,
  isNumbering = true,
  viewText,
  deleteText,
  editText,
  approvedText,
  rejectedText,
  emptyMessageTitle,
  emptyMessageDescription,
  activeSize,
  sizing,
  withPagination = true,
  theme,
  handleAdd,
  handleDelete,
  handleEdit,
  handleView,
  handleApproved,
  handleRejected,
  handleChangeSequence,
  handleDownload,
  handleCustomAction,
  handleCheckBox,
}) => {
  const [activePage, setActivePage] = useState(1);
  const [activeSizePage, setActiveSizePage] = useState(10);
  const [sizePage, setSizePage] =
    useState<DropdownComponent[]>(defaultSizeTable);
  const [sortedData, setSortedData] = useState([...data]);
  const [sortConfig, setSortConfig] = useState<SortedConfigurationTable>({
    key: null,
    direction: 'asc'
  });

  useEffect(() => {
    if (sizing) {
      setSizePage(sizing);
    }
  }, [sizing]);

  useEffect(() => {
    if (activeSize) {
      setActiveSizePage(activeSize);
    }
  }, [activeSize]);

  useEffect(() => {
    let sorted = [...data];
    if (sortConfig.key !== null) {
      sorted.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    setSortedData(sorted);
  }, [data, sortConfig]);

  useEffect(() => {
    setActivePage(1);
  }, [data]);

  const onSort = (column) => {
    let direction: SortDirection = 'asc';
    if (sortConfig.key === column.id && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key: column.id, direction });
  };

  if (loading) {
    return <LoaderDataTables />;
  }

  const startIndex = (activePage - 1) * activeSizePage;
  const endIndex = startIndex + activeSizePage;
  const limitedData = sortedData.slice(startIndex, endIndex);

  return (
    <section className="wrapper-datatables">
      <Table.ScrollContainer minWidth={650}>
        <Table
          striped={theme?.type !== 'dark'}
          bg={theme?.colors?.card}
          withRowBorders={false}
        >
          <THead
            data={data}
            theme={theme}
            columns={columns}
            isNumbering={isNumbering}
            sortConfig={sortConfig}
            onSort={onSort}
          />
          <TBody
            theme={theme}
            activePage={activePage}
            activePageSize={activeSizePage}
            columns={columns}
            data={limitedData}
            rawData={data}
            isNumbering={isNumbering}
            viewText={viewText}
            approvedText={approvedText}
            rejectedText={rejectedText}
            editText={editText}
            deleteText={deleteText}
            handleAdd={handleAdd}
            handleDelete={handleDelete}
            handleEdit={handleEdit}
            handleView={handleView}
            handleApproved={handleApproved}
            handleRejected={handleRejected}
            handleDownload={handleDownload}
            handleCustomAction={handleCustomAction}
            handleCheckBox={handleCheckBox}
            emptyMessageTitle={emptyMessageTitle}
            emptyMessageDescription={emptyMessageDescription}
            handleChangeSequence={handleChangeSequence}
          />
        </Table>
      </Table.ScrollContainer>
      {withPagination && (
        <TPagination
          theme={theme}
          data={data}
          activeSizePage={activeSizePage}
          setActiveSizePage={(size) => {
            setActiveSizePage(size);
            setActivePage(1);
          }}
          sizePage={sizePage}
          activePage={activePage}
          setActivePage={setActivePage}
        />
      )}
    </section>
  );
};

export default DataTables;
